<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    :items="tuitionPeriods"
    item-value="id"
    item-text="displayTitle"
    @change="onChange"
    v-on:input="$emit('input', $event)"
    :loading="loading"
    outlined
    dense
    return-object
  />
</template>

<script>
import { mapGetters } from 'vuex'
import { SalaryPeriod } from '@/plugins/api'
import { sortPeriod } from '../../../modules/tuitionFee/head-fee/helper/period'

export default {
  data: () => ({ periods: [], loading: false }),
  props: {
    filter: Object,
    defaultDivisions: Object,
    options: Object
  },
  computed: {
    ...mapGetters('app', ['currentSchoolYear'])
  },
  created() {
    if (this.defaultDivisions) {
      this.periods = this.defaultDivisions
    }

    this.fetchPeriods()
  },
  methods: {
    async fetchPeriods() {
      this.loading = true
      const periods = await SalaryPeriod.fetch({ ...this.filter, _limit: -1 })
      this.periods = sortPeriod(periods)
      this.loading = false
    },
    onChange(data) {
      this.$emit('change', data)
    }
  },
  watch: {
    filter() {
      this.fetchPeriods()
    }
  }
}
</script>
